import { render } from "./Videos.vue?vue&type=template&id=aef2444e&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"

import "./Videos.vue?vue&type=style&index=0&id=aef2444e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benme\\Documents\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef2444e"]])

export default __exports__